module.exports = kolibriGlobal.lib.logging;